import { z } from 'zod';

export const contentLegacyGuideSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  contentId: z.number().int().positive('Content ID must be positive'),
  count: z.number().int().min(1, 'Count must be non-negative'),
});

export const contentLinkSchema = z.object({
  title: z.string().min(1, 'Title is required'),
  url: z.string().url('Must be a valid URL'),
  coverImage: z.string().min(1, 'Cover image is required'),
});

export const contentTabSchema = z.object({
  name: z.string().min(1, 'Name is required'),
});

export const extrasFormSchemaMap = {
  ContentLegacyGuide: contentLegacyGuideSchema,
  ContentLink: contentLinkSchema,
  ContentTab: contentTabSchema,
} as const;

export const validateImage = async (
  file: File,
  minWidth = 1005,
  minHeight = 450,
): Promise<{ isValid: boolean; error?: string; url?: string }> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    console.log('Validating image:', img.src);

    img.onload = () => {
      URL.revokeObjectURL(img.src);

      if (img.width < minWidth || img.height < minHeight) {
        resolve({
          isValid: false,
          error: `Image must be larger than ${minWidth}x${minHeight} pixels.`,
        });
        return;
      }

      resolve({ isValid: true });
    };

    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      resolve({
        isValid: false,
        error: 'Failed to load image. Please try a different file.',
      });
    };
  });
};
